import { Route } from '@angular/router';
import { accessGuard } from '@guards';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./simulation/simulation-page.component').then(
        (m) => m.SimulationPageComponent,
      ),
  },
  {
    path: '**',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./simulation/simulation-page.component').then(
        (m) => m.SimulationPageComponent,
      ),
  },
];
